import { apiCall } from "../service/api-service";

export const getQuickReportApi = async (type = "lead") => {
  const response = await apiCall("POST", "report/get_quick_report", { module: type });
  return response.data;
};

export const getLeadReportApi = async (params) => {
  const payload = {
    from_date: "2023-01-01",
    to_date: "2025-12-31",
    lead_owner_id: params.lead_owner_id || "",
    lead_status: params.lead_status || "",
    city_id: params.city_id || "",
    state_id: params.state_id || "",
    country_id: params.country_id || "",
  };
  const response = await apiCall("POST", "report/leads", payload);
  return response.data;
};

export const getCallReportApi = async (params, apiValue) => {
  const response = await apiCall("POST", `report/${apiValue}`, params);
  return response.data;
};

export const exportQuickReportApi = async (apiValue, start_date, end_date) => {
  const payload = {
    start_date: start_date,
    end_date: end_date,
  };
  return apiCall("POST", `report/${apiValue}`, payload);
};

export const getReportTypesApi = async () => {
  const response = await apiCall("GET", "report/get_report_types");
  return response.data;
};

export const getReportFieldsApi = async (reportType = "") => {
  const payload = reportType ? { report_type: reportType } : {};
  const response = await apiCall("POST", "report/report_fields", payload);
  return response.data;
};

export const downloadBase64File = (base64String, fileName) => {
  const binary = atob(base64String);
  const array = [];

  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  const blob = new Blob([new Uint8Array(array)], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
